(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  L.MassEvents = (function() {
    function MassEvents() {
      this.detach = bind(this.detach, this);
      this.attach = bind(this.attach, this);
      this.__events = [];
    }

    MassEvents.prototype.on = function(objectevents, cb) {
      var self;
      self = this;
      return List.map(function(i) {
        if (!$.isArray(i[1])) {
          return self.attach(i[0], i[1], cb);
        } else {
          return List.map(function(e) {
            return self.attach(i[0], e, cb);
          }, i[1]);
        }
      }, objectevents);
    };

    MassEvents.prototype.attach = function(source, event, cb) {
      source.on(event, cb);
      return this.__events.push({
        'source': source,
        'event': event,
        'cb': cb
      });
    };

    MassEvents.prototype.detach = function(source, event, cb, del) {
      var i, j, k, len, ref;
      if (del == null) {
        del = true;
      }
      source.off(event, cb);
      if (del) {
        ref = this.__events;
        for (j = k = 0, len = ref.length; k < len; j = ++k) {
          i = ref[j];
          if (i.source === source && i.event === event && i.cb === cb) {
            this.__events.splice(j, 1);
            return;
          }
        }
      }
    };

    MassEvents.prototype.destroy = function() {
      var i, j, k, len, ref, results;
      ref = this.__events;
      results = [];
      for (j = k = 0, len = ref.length; k < len; j = ++k) {
        i = ref[j];
        if (i != null) {
          this.detach(i.source, i.event, i.cb, false);
        }
        results.push(delete this.__events[j]);
      }
      return results;
    };

    MassEvents.prototype.off = function(objectevents, cb) {
      var self;
      self = this;
      return List.map(function(i) {
        if (!$.isArray(i[1])) {
          return self.detach(i[0], i[1], cb);
        } else {
          return List.map(function(e) {
            return self.detach(i[0], e, cb);
          }, i[1]);
        }
      }, objectevents);
    };

    return MassEvents;

  })();

}).call(this);
